<template>
  <div>
    <el-card>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>添加套餐商品</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px">
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="商品类型" prop="type">
              <el-select v-model="addForm.type" placeholder="请选择商品类型">
                <el-option v-for="(item, index) in goodsTypeList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入商品名称" auto-complete="off" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品封面" prop="img">
              <div class="upload-div">
                <div class="upload-content">
                  <div>
                  </div>
                  <div class="content-texts">
                    <span
                      class="content-texts">至少上传1张，最多上传3张，JPG、PNG格式，每张图片不超过2M,第一张为主图，可拖动图片进行排序，建议尺寸750*560px或4：3</span>
                  </div>
                </div>
              </div>
              <div class="img-list">
                <div v-if="addForm.imgs.length">
                  <draggable v-model="addForm.imgs" @update="datadragEnd" :options="{ animation: 500 }">
                    <!-- <transition-group> -->
                    <div class="upload-img" v-for="(item, index) in addForm.imgs" :key="index">
                      <!-- <img class="upload-img" :src="item" alt /> -->
                      <el-image class="upload-img" :src="item" :preview-src-list="addForm.imgs"></el-image>
                      <div @click="deleteImg(index)" class="delete-img">
                        <i class="el-icon-close icons"></i>
                      </div>
                      <div class="main-img">
                        {{ index == 0 ? '主图' : '附图' + index }}
                      </div>
                    </div>
                    <!-- </transition-group> -->
                  </draggable>
                </div>
                <div v-if="addForm.imgs.length < 3">
                  <el-upload class="crm-upload" :action="fileObj.url" :on-remove="handleRemove"
                             :on-change="handleChange" :before-upload="beforeUpload" :on-success="UploadSuccess"
                             :headers="reqData" :on-exceed="handleExceed" multiple :limit="3" list-type="picture"
                             :show-file-list="false">
                    <img class="upload-img" :src="defaultImg" alt/>
                  </el-upload>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="上传视频" prop="videoUrl" v-loading="loadVideo">
              <div class="editPointC">
                <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="upload"
                           :http-request="videoUrlUploadRequest1">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <video class="currencySetting-image" style="margin-left: 20px;float:right;" v-if="addForm.videoUrl"
                         :src="addForm.videoUrl" height="100" width="160"></video>
                </el-upload>
                <div class="paySetting-tips">
                  支持mp4、avi、wmv格式，大小不超过2GB
                </div>
              </div>
            </el-form-item>

          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="所属科目" prop="subjectId">
              <el-cascader style="width: 100%" clearable v-model="courseIds" :show-all-levels="false"
                           :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList"
                           @change="subjectSearchChange"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8" v-if="this.addForm.type !== '免费课程'">
            <el-form-item label="是否免费" prop="free">
              <el-radio v-model="addForm.free" label="-1" @change="freeChange">付费</el-radio>
              <el-radio v-model="addForm.free" label="1" @change="freeChange">免费</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="机构结算价" prop="agentPrice">
              <el-input type="number" min="0" v-model="addForm.agentPrice" placeholder="请输入机构结算价(RMB)"
                        auto-complete="off" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="允许分享" prop="free">
              <el-radio v-model="addForm.hasShare" label="1">是</el-radio>
              <el-radio v-model="addForm.hasShare" label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="原价" prop="originalPrice">
              <el-input type="number" min="0" v-model="addForm.originalPrice" @change="originalPriceChange"
                        placeholder="请输入原价(RMB)" auto-complete="off" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="售价" prop="price">
              <el-input :disabled=" addForm.free == '1'" type="number" min="0" v-model="addForm.price" placeholder="请输入售价" auto-complete="off" maxlength="10">
                <template slot="append">
                  <el-select style="width: 90px" :disabled="addForm.free == '1'" v-model="discount"
                             @change="discountChange()" :placeholder="placeholderdiscount">
                    <el-option v-for="(item, index) in discountOptions" :key="index" :label="item.label"
                               :value="item.value"></el-option>
                  </el-select>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="机构等级价" prop="agentLevelGoodsPriceList">
              <el-input v-for="(item, index) in agentLevelList" :key="index" type="number" min="0"
                        v-model="agentLevelList[index].price" :placeholder="'请输入' + item.name + '原价(RMB)'"
                        auto-complete="off" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="显示销量" prop="sellCount">
              <el-input min="0" type="number" v-model="addForm.sellCount" placeholder="请输入显示销量" auto-complete="off"
                        maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="有效天数" prop="validDay">
              <el-input type="number" min="0" v-model="addForm.validDay" placeholder="请输入有效天数" auto-complete="off"
                        :disabled="validDayDisabled" maxlength="10">
                <template slot="append">
                  <el-checkbox v-model="validDayRadio" label="1" @change="validDayNull()">不限</el-checkbox>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="上架时间" prop="onTime">
              <el-date-picker style="width: 100%" :picker-options="pickerOptions1" value-format="yyyy-MM-dd HH:mm:ss"
                              v-model="addForm.onTime" @change="timechange" type="datetime"
                              placeholder="请选择上架时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="失效时间" prop="offTime">
              <div style="width: 100%">
                <el-date-picker style="width: calc(100% - 60px)" :picker-options="pickerOptions2"
                                v-model="addForm.offTime" @change="timechange" :disabled="offTimeDisabled"
                                value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                placeholder="请选择失效时间"></el-date-picker>
                <el-checkbox v-model="offTimeRadio" label="1" @change="offTimeNull()">不限</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="提问次数" prop="questionTimes">
              <el-input-number v-model="addForm.questionTimes" :min="1" label="提问次数"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="课程简介">
              <el-input v-model="addForm.summary" placeholder="请输入课程简介" auto-complete="off" maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品介绍" prop="detail">
              <div style="background: #fff">
                <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="课程推荐">
              <el-tag v-for="tag in checkSureList" :key="tag.id">
                {{ tag.name }}
              </el-tag>
              <p>
                <el-button type="primary" icon="el-icon-plus" circle @click="addFormVisible = true, getList()
                "></el-button>
              </p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <el-button @click="addFormBack">重置</el-button>
        <el-button type="primary" @click="addGoodsInfo" :loading="blockAddGoodsInfo">提交</el-button>
      </div>
    </el-card>

    <el-dialog :title="'添加推荐商品'" :visible.sync="addFormVisible" width="60%" left :close-on-click-modal="false">
      <el-form :label-width="formLabelWidth">
        <div>
          <el-row :span="24">
            <el-col :sm="5" :md="5" :lg="5">
              <el-form-item label="所属分类" label-width="80px" prop="pid">
                <el-cascader v-model="searchForm.subjectIds" :show-all-levels="false" ref="tree" collapse-tags
                             :options="subjectTreeList" :props="subjectTreeProps" clearable></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :sm="5" :md="5" :lg="5">
              <el-form-item label="是否限购" label-width="80px" prop="flashSaleType">
                <el-select v-model="searchForm.flashSaleType" placeholder="请选择" clearable>
                  <el-option value="">全部</el-option>
                  <el-option :label="'是'" :value="'1'"></el-option>
                  <el-option :label="'否'" :value="'-1'"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item label="商品名称">
                <el-input v-model="searchForm.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table :data="tableList" ref="multipleTableNew" tooltip-effect="dark" style="width: 100%"
                        @selection-change="handleSelectionChange" :row-key="getRowKey" highlight-current-row border
                        v-loading="loading1" element-loading-text="拼命加载中"
                        element-loading-background="rgba(255, 255, 255, 0.8)">
                <el-table-column type="selection" :reserve-selection="true" width="55">
                </el-table-column>

                <el-table-column prop="name" show-overflow-tooltip label="商品">
                  <template slot-scope="row">
                    <el-row>
                      <el-col :span="8">
                        <span>
                          <img style="margin-right: 10px" width="100%" height="44px" :src="
                            row.row.logo
                              ? row.row.logo
                              : '../../../static/image/noImg.png'
                          "/>
                        </span>
                      </el-col>
                      <el-col :span="16">
                        <span style="color: rgb(77, 148, 255); margin-left: 10px">{{ row.row.name }}</span>
                        <span style="display: block; margin-left: 10px">
                          <span style="color: red">￥{{ row.row.price }}</span>
                          <span style="
                              text-decoration: line-through;
                              color: rgb(162, 170, 188);
                            ">￥{{ row.row.originalPrice }}</span>
                        </span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="agentPrice" label="售价">
                  <template slot-scope="row">
                    <span style="display: block">
                      <span style="color: red">￥{{ row.row.price }}</span>
                      <span style="
                          text-decoration: line-through;
                          color: rgb(162, 170, 188);
                        ">￥{{ row.row.originalPrice }}</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                  <template slot-scope="row">{{
                    row.row.validDay ? row.row.validDay + '天' : '不限'
                    }}
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="subjectCourseName"
                                 label="所属科目"></el-table-column>
              </el-table>
              <el-pagination background layout="total, prev, pager, next" style="margin-top: 20px; text-align: right"
                             :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber"
                             @size-change="sizeChange" @current-change="currentChange"></el-pagination>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import UE from "../conmom/CKEditorInformation.vue"
  import draggable from "vuedraggable"
  import {uploadOSS} from "../../upload/upload";
  import {mapGetters} from "vuex";

  export default {
    components: {UE, draggable},
    data() {
      let that = this
      return {
        addFormVisible: false,
        searchForm: {
          sell: 1,
          name: "",
          subjectIds: [],
        },
        tableList: [],
        loading1: false,
        arrsSelect: [],
        checkSureList: [],
        checkList: [],
        page: {
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: "",
          sortOrder: "",
        },
        agentLevelList: [],
        validDayRadio: null,
        material: 0,
        pickerOptions1: {
          disabledDate(time) {
            return (
              time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
            )
          }
        },
        pickerOptions2: {
          disabledDate(time) {
            return (
              time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
            )
          }
        },
        postDisabled: false,
        blockAddGoodsInfo: false,
        offTimeDisabled: false,
        defaultImg: "../../../static/image/defaultImg2.png",
        fileObj: {
          url: process.env.BASE_URL + "/system/uploadFile"
        },
        ueTtext: "",
        placeholderdiscount: "不打折",
        subjectTreeList: [], //科目

        addTeacherList: [],
        dictionaryIds: [], //分类id
        validDayDisabled: false,
        offTimeRadio: null,
        checked: false,
        addForm: {
          recommendGoodsIds: [],
          name: "",
          free: "-1",
          hasShare: '0',
          imgs: [],
          img: "",
          validDay: "365",
          type: "",
          subjectId: "",
          agentPrice: "",
          originalPrice: "",
          price: "",
          material: "",
          sell: "1",
          stock: "9999",
          sellCount: 0,
          onTime: "",
          offTime: "",
          questionTimes: 1000,
          summary: "",
          detail: "",
          agentLevelGoodsPriceList: []
        },
        formLabelWidth: "86px",
        addFormRules: {
          name: [
            {
              required: true,
              message: "请输入商品名称",
              trigger: "blur"
            },
            {
              min: 1,
              max: 20,
              message: "商品名称长度在1到100个字"
            }
          ],
          type: {
            required: true,
            message: "请选择商品类型",
            trigger: "change"
          },
          free: {
            required: true,
            message: "请选择付费",
            trigger: "change"
          },
          onTime: {
            required: true,
            message: "请选择上架时间",
            trigger: "change"
          },
          img: {
            required: true,
            message: "请选择商品图片",
            trigger: "change"
          },
          // img: [
          //   {
          //     required: true,
          //     message: "请输入图标",
          //     trigger: "blur"
          //   },
          //   {
          //     min: 1,
          //     max: 300,
          //     message: "图标长度在1到300个字"
          //   }
          // ],

          tags: [
            {
              required: true,
              message: "请输入标签",
              trigger: "blur"
            },
            {
              min: 1,
              max: 1000,
              message: "标签长度在1到1000个字"
            }
          ],
          subjectId: [
            {
              required: true,
              message: "请选择所属科目",
              trigger: "change"
            }
          ],
          agentPrice: [
            {
              required: true,
              message: "请输入机构结算价",
              trigger: "change"
            }
          ],
          postpone: [
            {
              required: true,
              message: "请输入是否支持延期",
              trigger: "blur"
            },
            {
              pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
              message: "是否支持延期格式不正确"
            }
          ],
          sellCount: [
            {
              required: true,
              message: "请输入显示销量",
              trigger: "blur"
            },
            {
              pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
              message: "显示销量格式不正确"
            }
          ],
          price: [
            {
              required: true,
              message: "请输入售价",
              trigger: "blur"
            },
            {
              pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
              message: "售价格式不正确"
            }
          ],
          originalPrice: [
            {
              required: true,
              message: "请输入原价",
              trigger: "blur"
            },
            {
              pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
              message: "原价格式不正确"
            }
          ],
          validDay: [
            {
              required: true,
              message: "请输入有效天数",
              trigger: "blur"
            },
            {
              pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
              message: "有效天数格式不正确"
            }
          ],
          summary: [
            {
              required: true,
              message: "请输入摘要",
              trigger: "blur"
            },
            {
              min: 1,
              max: 1000,
              message: "摘要长度在1到1000个字"
            }
          ],
          detail: [
            {
              required: true,
              message: "请输入详细介绍",
              trigger: "blur"
            },
            {
              min: 1,
              max: 65535,
              message: "详细介绍长度在1到65535个字"
            }
          ]
        },
        discountOptions: [
          {
            value: "1",
            label: "不打折"
          },
          {
            value: "0.9",
            label: "9折"
          },
          {
            value: "0.8",
            label: "8折"
          },

          {
            value: "0.7",
            label: "7折"
          },
          {
            value: "0.6",
            label: "6折"
          },
          {
            value: "0.5",
            label: "5折"
          },
          {
            value: "0.4",
            label: "4折"
          },
          {
            value: "0.3",
            label: "3折"
          },
          {
            value: "0.2",
            label: "2折"
          },
          {
            value: "0.1",
            label: "1折"
          }
        ],
        goodsTypeList: [], //type
        courseIds: [], //科目
        discount: "",
        dictionaryIdList: [], // 分类
        dictionaryProps: {
          value: "id",
          label: "name",
          children: "dictionaries",
          multiple: true
        },
        subjectTreeProps: {
          value: "id",
          label: "name",
          children: "children"
        },
        loadVideo: false,
      }
    },
    watch: {

      "addForm.price": function (newVal) {
        if (Number(this.addForm.originalPrice) > 0) {
          this.placeholderdiscount =
            (
              Number(this.addForm.price) / Number(this.addForm.originalPrice)
            ).toFixed(2) *
            10 ==
            10
              ? "不打折"
              : (
                Number(this.addForm.price) / Number(this.addForm.originalPrice)
              ).toFixed(2) *
              10 +
              "折"
          if (Number(this.addForm.price) > Number(this.addForm.originalPrice)) {
            this.$message.error("输入错误，售价不能大于原价！！！")
            // this.addForm.price = "";
          }
        }
      }
    },

    methods: {
      videoUrlUploadRequest1(file) {
        this.loadVideo = true
        console.log("file", file);
        const isJPG = file.file.type === "video/mp4" || file.file.type === "video/avi" || file.file.type === "video/wmv";
        if (!isJPG) {
          this.$message.error("上传视频只支持mp4、avi、wmv格式!");
          return;
        }
        if (file.file.size / 1024 / 1024 > 2000) {
          this.$message.error("视频大小不能超过2G");
          return;
        } else {
          uploadOSS(file, "generalSetting").then((result) => {
            this.$set(this.addForm, "videoUrl", result);
            this.loadVideo = false
          });
        }
      },
      getRowKey(row) {
        return row.id;
      },
    freeChange (val) {
      if (val == "1") {
        // this.addForm.originalPrice = 0;
        this.addForm.price = 0
      }else{
       this.addForm.price = parseInt(
        (this.discount ? this.discount : 1) * this.addForm.originalPrice
      )
      }
    },

      getList() {
        this.loading1 = true;
        let arr = [];
        if (this.searchForm.subjectIds.length > 0) {
          this.searchForm.subjectIds.forEach((item) => {
            arr.push(item.reverse()[0]);
          });
        }
        let obj = {
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
          sortName: this.page.sortName,
          sortOrder: this.page.sortOrder,
          agentId: this.loginData.agentId,
          flashSaleType: this.searchForm.flashSaleType,
          name: this.searchForm.name,
          subjectIds: arr,
        };


        this.api.goodsInfo['pageList'](obj)
          .then((result) => {
            this.loading1 = false;
            this.tableList = result.data.records;
            this.page.total = result.data.total;
            this.arrsSelect = [];
          })

          .catch((error) => {
            console.log(error);
          });
      },
      currentChange(pageNumber) {
        this.page.pageNumber = pageNumber;
        this.getList();
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.getList();
      },

      handleSelectionChange(val) {
        this.checkList = val;
        console.log(val);
      },
      closeDialog() {
        console.log(this.checkList);
        this.checkSureList = this.checkList
        // recommendGoodsIds:[]
        // this.homePageList[this.activeIndex].schoolPageItemList[
        //         this.itemIndex
        //         ].relationId = this.checkList.id;
        // this.homePageList[this.activeIndex].schoolPageItemList[this.itemIndex].title =
        //         this.activeObjectType != "商品" && this.activeObjectType != "机构"
        //                 ? this.checkList.title
        //                 : this.checkList.name;
        // this.homePageList[this.activeIndex].schoolPageItemList[
        //         this.itemIndex
        //         ].schoolPageInfo = {
        //     ...this.checkList,
        // };
        this.itemIndex = "";
        this.addFormVisible = false;
      },
      // 获取分类
      getDictionaryTreeByParentId() {
        this.api.dictionary.getDictionaryTreeByParentId({id: "505558045364223"}).then(res => {
          this.dictionaryIdList = this.getTreeData(res.data)
        }).catch(error => {
          console.log(error)
        })
      },
      getTreeData(data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].dictionaries.length === 0) {
            data[i].dictionaries = undefined;
          } else {
            this.getTreeData(data[i].dictionaries);
          }
        }
        return data;
      },
      freeChange(val) {
        if (val == "1") {
          // this.addForm.originalPrice = 0;
          this.addForm.price = 0
        }
      },

      validDayNull() {
        if (this.validDayRadio == 1) {
          this.validDayDisabled = true
          this.addForm.validDay = null
          this.addFormRules.validDay = [
            {
              required: false,
              message: "请输入有效天数",
              trigger: "blur"
            },
            {
              pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
              message: "有效天数格式不正确"
            }
          ]
        } else {
          this.validDayDisabled = false
          this.addFormRules.validDay = [
            {
              required: true,
              message: "请输入有效天数",
              trigger: "blur"
            },
            {
              pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
              message: "有效天数格式不正确"
            }
          ]
        }
      },
      originalPriceChange() {
        if (this.addForm.free == "1") {
        } else {
          this.addForm.price = this.addForm.originalPrice
          this.discountChange()
        }
      },
      checkboxChange(val) {
        if (val) {
          this.addForm.price = this.addForm.originalPrice
        }
      },
      timechange() {
        if (this.addForm.offTime && this.addForm.onTime) {
          if (this.addForm.onTime >= this.addForm.offTime) {
            return this.$message.error("上架时间不能大于等于失效时间！！！")
          }
        }
      },
      offTimeNull() {
        if (this.offTimeRadio == 1) {
          this.offTimeDisabled = true
          this.addForm.offTime = null
        } else {
          this.offTimeDisabled = false
        }
      },
      discountChange() {
        this.checked = false
        this.addForm.price = parseInt(
          (this.discount ? this.discount : 1) * this.addForm.originalPrice
        )
      },
      subjectSearchChange() {
        if (this.courseIds) {
          this.addForm.subjectId = this.courseIds[1]
        } else {
          this.searchForm.subjectId = ""
        }
      },
      // 分类
      dictionaryIdsChange() {
        if (this.dictionaryIds) {
          this.addForm.dictionaryIdList = [];
          this.dictionaryIds.forEach(e => {
            let len = e.length;
            this.addForm.dictionaryIdList.push(e[len - 1])
          })
        } else {
          this.addForm.dictionaryIdList = [];
        }
      },
      deleteImg(index) {
        this.addForm.imgs.splice(index, 1)
        console.log(this.addForm.imgs)
      },
      datadragEnd(evt) {
        this.$forceUpdate()
        evt.preventDefault()
      },
      getSubjectTreeList() {
        // 获取课程
        this.api
          .getSubjectTreeList()
          .then(result => {
            for (let item of result.data) {
              if (item.children.length != 0) {
                for (let items of item.children) {
                  delete items.children

                }
              }
            }
            this.subjectTreeList = result.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      UploadSuccess(res, file, fileList, val) {
        this.addForm.imgs.push(res.data)
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `商品图片最多可选择3张，本次选择了 ${files.length
          } 个图片，共选择了 ${files.length + fileList.length} 个图片`
        )
      },
      handleRemove(file, fileList) {
      },
      handleChange(file, fileList) {
      },
      beforeUpload(file) {
        if (this.addForm.imgs.length == 3) {
          return this.$message.error("商品图片最多上传三张")
        }
        const isJPG = file.type.indexOf("image") > -1
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isJPG) {
          this.$message.error("上传文件必须是图片哦!")
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!")
        }
        return isJPG && isLt2M
      },
      addFormBack() {
        this.addForm.name = ""
        this.addForm.img = ""
        this.addForm.sell = 1
        this.addForm.imgs = []
        this.addForm.type = ""
        this.addForm.validDay = "365"
        this.addForm.subjectId = ""
        this.addForm.originalPrice = ""
        this.addForm.price = ""
        this.addForm.material = ""
        this.addForm.stock = ""
        this.addForm.sellCount = 0
        this.addForm.onTime = ""
        this.addForm.offTime = ""
        this.addForm.summary = ""
        this.addForm.detail = ""
        //this.$router.push({ path: "/goodsInfo" });
      },
      getGoodsTypeList() {
        this.api.goodsInfo
          .getGoodsTypeList({})
          .then(result => {
            if (result.success) {
              this.goodsTypeList = result.data
            } else {
              this.$message.error(result.message)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      addGoodsInfo() {
        if (this.blockAddGoodsInfo) {
          return false
        }
        this.blockAddGoodsInfo = true
        if (this.$refs.myQuillEditorTitle._data.content) {
          this.agentLevelList.forEach(e => this.addForm.agentLevelGoodsPriceList.push({
            agentLevelId: e.id,
            price: e.price
          }))
          this.checkSureList.forEach(e => this.addForm.recommendGoodsIds.push(e.id))
          console.log(this.addForm.recommendGoodsIds);
          this.addForm.detail = this.$refs.myQuillEditorTitle._data.content
          this.addForm.img = this.addForm.imgs.toString()
          this.$refs.addForm.validate(valid => {
            if (valid) {
              if (
                Number(this.addForm.price) > Number(this.addForm.originalPrice)
              ) {
                return this.$message.error("输入错误，售价不能大于原价！！！")

              }
              if (this.addForm.type == '免费课程') {
                this.addForm.free = '1'
              }
              var flagSetPrice = this.addForm.agentLevelGoodsPriceList.some(item => item.price && item.price > 0)
              this.addForm.agentLevelGoodsPriceList.forEach(v => {
                if (!flagSetPrice) v.price = this.addForm.agentPrice
              })
              this.api.goodsInfo
                .addGoodsInfo(this.addForm)
                .then(result => {
                  if (result.success) {
                    this.$router.push({
                      path: "/goodsInfo"
                    })
                  } else {
                    this.blockAddGoodsInfo = false
                    this.$message.error(result.message)
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            } else {
              this.blockAddGoodsInfo = false
              return false
            }
          })
        } else {
          this.blockAddGoodsInfo = false
          this.$message.error("商品介绍不能为空")
        }
      },
      getAgentLevelList() {
        this.api.agentLevel.getAgentLevelList().then(result => {
          if (result.success) {
            this.agentLevelList = result.data
          } else {
            this.$message.error(result.message);
          }
        })
      }
    },

    computed: {
      ...mapGetters(["loginData"]),
      reqData() {
        return this.$store.state.user;
      },
    },
    mounted() {
      this.addForm.onTime = this.format("yyyy-MM-dd hh:mm:ss", new Date())
      this.getDictionaryTreeByParentId()
      this.getGoodsTypeList()
      this.getSubjectTreeList()
      this.getAgentLevelList()
    }
  }
</script>
<style lang="less" scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .list-name-img {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  .img-list {
    display: flex;
    margin-top: 10px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

    .select {
      opacity: 0.6;
      background: #333;
    }

    .main-img {
      margin: 0 10px;
      text-align: center;
      font-size: 14px;
      margin-top: -20px;
      width: 160px;
      height: 40px;
      line-height: 40px;
    }

    .upload-img {
      display: inline-block;
      width: 160px;
      height: 100px;
      border-radius: 4px;
      margin: 0 10px;
      position: relative;
      cursor: pointer;
      padding: 0px;
    }

    .delete-img {
      top: -5px;
      right: -10px;
      // width: 160px;
      // height: 100px;
      border-radius: 4px;
      position: absolute;
      z-index: 12;
      cursor: pointer;

      .icons {
        color: #fff;
        background-color: #333;
        border-radius: 50%;
        font-weight: bolder;
        z-index: 1343;
        font-size: 20px;
      }
    }
  }

  .upload-div {
    display: flex;
    flex-direction: row;

    .upload-content {
      // margin-left: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .content-text {
        width: 80px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid rgb(77, 148, 255);
        color: rgb(77, 148, 255);
        font-size: 12px;
        line-height: 32px;
      }

      .content-texts {
        color: rgb(162, 170, 188);
        font-size: 12px;
        white-space: nowrap;
        // margin-left: 5px;
      }
    }
  }

  .el-radio + .el-radio {
    margin-left: 0px !important;
  }

  .margin-left {
    margin: 0px !important;
  }


  .avatar-uploader-logo {
    margin-top: 20px;
  }

  .avatar-uploader-logo .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-logo .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 57px;
    color: #0C0C0C;
    width: 160px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    background-color: #F7F7F7;
    margin: 0 10px;
  }

  .avatar {
    width: 60px;
    height: 60px;
    display: block;
  }

  .editPointC .el-upload--text {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/goods/addGoodsTaocan.vue